module.exports = __webpack_public_path__ + "img/file-archive-light.d71f0fc4.svg";